import { render, staticRenderFns } from "./carTraffic.vue?vue&type=template&id=0d0d04c2&scoped=true&"
import script from "./carTraffic.vue?vue&type=script&lang=js&"
export * from "./carTraffic.vue?vue&type=script&lang=js&"
import style0 from "./carTraffic.vue?vue&type=style&index=0&id=0d0d04c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0d04c2",
  null
  
)

export default component.exports